exports.baseURL = "https://sugarhub.in/";
exports.secretKey = "b39a5f7c0d42ea9c77c4e1f2f83bd0a14d3a96ef59ca1b88e7132cdf0f9e64f1c5b7a8e3";
exports.projectName = "Sugarhub";
